
<sm-misc-title-bar [headerCustomTemplate]="addButton" pageTitle={{pageTitle}} [showBackButton]="false">
    <ng-template #addButton>
      <div class="d-flex search-field">
        <!-- <mat-form-field appearance="outline" class="me-2" *ngIf="toShowInventoryItems">
          <mat-label>{{ 'services.label' | translate }}</mat-label>
          <input
          [formControl]="searchString"
           
            matInput
            placeholder="{{ 'services.placeholder' | translate }}"
            (keyup)="searchServiceData()"
          />
          <button
          
            mat-button
            *ngIf="!searchString.value"
            matSuffix
            mat-icon-button
            aria-label="Clear"
          >
            <mat-icon>search</mat-icon>
          </button>
          <button
          mat-button
          *ngIf="searchString.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="reset()"
        >
          <mat-icon >close</mat-icon>
        </button>
        </mat-form-field> -->
  
        <button
        mat-icon-button
        mat-dialog-close
        class="align-self-end"
        color="accent"
      >
        <mat-icon style=" color: #000; position: relative; top: -5px;">close</mat-icon>
      </button>
      </div>
    </ng-template>
  </sm-misc-title-bar>
  <!-- inventory increase/decrease modal -->
    <mat-dialog-content *ngIf="!toShowInventoryItems && (operation_type == 1 || operation_type == 2 || operation_type == 3)" style="min-width: 400px;" >
      <div class="text-fieldss">
        <h3 style="    font-weight: 700;
        margin-bottom: 5px;">{{selectedInventoryData[0].item_name}}</h3>
        <p>{{selectedInventoryData[0].quantity_info}}</p>
        <p>Current stock: <strong>{{selectedInventoryData[0].current_stock}} {{selectedInventoryData[0].purchase_unit}}</strong> </p>
        <p>Minimum stock: <strong> {{selectedInventoryData[0].min_stock}} {{selectedInventoryData[0].purchase_unit}}</strong></p>
      </div>
      <div class="text-fieldss">
        <mat-form-field appearance="outline">
          <mat-label>Purchase quantity</mat-label>
          <input smNumericOnly
            [(ngModel)]="purchaseListData.purchase_qty"
            matInput
  
          />
         
        </mat-form-field>
        <p style="position: relative; top: -10px;">Purchase unit: <strong>{{selectedInventoryData[0].purchase_unit}}</strong></p>
      </div>
      <div class="text-fieldss" *ngIf="selectedPurchaseType != 2">
        <mat-form-field appearance="outline">
          <mat-label>Purchase price</mat-label>
          <input 
            [(ngModel)]="purchaseListData.purchase_price"
            matInput
           smDecimalOnly  type="number"
          />
         
        </mat-form-field>
        <!-- <p style="position: relative; top: -10px;">Purchase unit: <strong>{{selectedInventoryData[0].purchase_unit}}</strong></p> -->
      </div>
      <div class="chip_cont" *ngIf="operation_type != 3">
        <mat-chip-listbox aria-label="Fish selection" class="mb-3">
          <mat-chip
            
      [ngClass]="{ selectedPurple: selectedPurchaseType == 2 }"
      (click)="changeChip(2)"
            >Reminder
          </mat-chip>
        </mat-chip-listbox>
      
        <mat-chip-listbox aria-label="Fish selection" class="mb-3">
          <mat-chip
            
            [ngClass]="{ selectedPurple: selectedPurchaseType == 1 }"
      (click)="changeChip(1)"
            >Purchased
          </mat-chip>
        </mat-chip-listbox>
      </div>
      <div *ngIf="selectedPurchaseType == 1">
        <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker3.open()" style="padding: 0px;">
            <mat-label>Select purchase date</mat-label>
            <input matInput [matDatepicker]="picker3" [(ngModel)]="purchaseListData.purchase_date" readonly [max]="maxDate">
            <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker #picker3 disabled="false"></mat-datepicker>
          </mat-form-field>
    </div>
      <div class="text-fieldss">
        <mat-form-field appearance="outline">
          <mat-label>Notes</mat-label>
          <textarea
            [(ngModel)]="purchaseListData.notes"
            matInput
          ></textarea>
         
        </mat-form-field>
      </div>
      
     
    </mat-dialog-content>
  
  
    <!-- inventory items -->
    <mat-dialog-content *ngIf="toShowInventoryItems" style="min-width: 80vw;">
      <div class="row" *ngIf="employeeData.length>0">
          <div class="col-sm-4" *ngFor="let item of employeeData">
              <div class="fl_orders" (click)="selectInventoryTemplate(item)">
                  <div class="top_section_order">
                      <div class="row">
                          <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                                      <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon>
                                  </div>
                          <div class="col-sm-3">
                              <div class="ads_sec">
                                  <div class="hm_icon_progr" *ngIf="item.imgThumbUrl && item.imgThumbUrl != 'null'">
                                      <img [src]="item.imgThumbUrl">
                                  </div>
                                  <div class="hm_icon_progr" *ngIf="!item.imgThumbUrl || item.imgThumbUrl == 'null'">
                                      <img src="../../../../assets/images/photo.png">
                                  </div>
                              </div>
                          </div>
                          <div class="col-sm-9">
                              <div class="order_dec">
                                  <h3 style="-webkit-box-orient: vertical;
                                  display: -webkit-box;
                                  -webkit-line-clamp: 1;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  white-space: normal;
                                  ">{{item.name}}</h3>
                                  <p>{{
                                    item.phone
                                  }}
                                  </p>
                                  <!-- <p>Home: Rs.{{item.home_rate}}, Shop: Rs.{{item.shop_rate}}
                                  </p> -->
                                  <p>{{item.addressInfo}}
                                  </p>
                                  <p>DOB: {{item.dob | date}}</p>
                                  <!-- <p class="pricecls">Price: <b>Rs.</b> </p> -->
                                  <!-- <input type="text" [(ngModel)]="item.price" [disabled]="item.isDisabled == true"> -->
                               </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          
<!--   
          <div *ngIf="datalength > inventoryItems.length" style="text-align: center;">
            <button
            style="
            width: 50%;
            border-radius: 50px;
        "
        mat-flat-button
        color="accent"
        (click)="seeMore()"
      >
        See more
      </button>
     
          </div> -->
          
  
      </div>
      <div class="row" *ngIf="isloading">
        <div class="loading_invoice" style="padding: 50px 0px; text-align: center;">
          <p>Loading Employees</p>
        </div>
      </div>
      <div class="row" *ngIf="!isloading && employeeData.length == 0">
        <div class="inven_sde" style="padding: 50px 0px; text-align: center;">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M486.616 284.337a25.422 25.422 0 0 0-24.752 19.776L387.635 340.4H362a78.372 78.372 0 0 0-32.822-34.24 8.009 8.009 0 0 0-1.917-.748 2324.964 2324.964 0 0 0-88.263-20.028c-.593-5.369-1.427-15.152-2.565-32.719a79.913 79.913 0 0 0 28.467-46.849h1.3a38.632 38.632 0 0 0 24.2-68.759l3.949-30.485a37 37 0 0 0-27.883-53.022 103.5 103.5 0 0 0-178.34-5.024 8.1 8.1 0 0 0-.644 1.266 175.719 175.719 0 0 0-10.523 93 38.628 38.628 0 0 0 29.972 63.028h1.3a79.838 79.838 0 0 0 25.277 44.16c-1.225 19.237-2.112 29.747-2.738 35.407a2324.476 2324.476 0 0 0-88.262 20.028 8.016 8.016 0 0 0-1.918.748 78.577 78.577 0 0 0-39.478 53.884 7.868 7.868 0 0 0-.146 1.27C-.063 391.193-.25 451.912.319 480.664A32.076 32.076 0 0 0 32.279 512h.3c101.066-.933 203.555-.933 304.621 0h.3a31.659 31.659 0 0 0 14.145-3.314 15.032 15.032 0 0 0 9.484 3.314h29.72a15.108 15.108 0 0 0 14.036-20.695l-11.923-29.953h4.615a13.725 13.725 0 0 0 13.731-13.687v-1.336l50.556 24.714A25.381 25.381 0 0 0 512 465.436V309.721a25.412 25.412 0 0 0-25.384-25.384Zm-151.159 134.42a8.145 8.145 0 0 0-.786-.052 4.843 4.843 0 0 1-4.34-4.8v-52.65a4.859 4.859 0 0 1 4.854-4.854h46.3v62.358Zm62.029 3.006v-68.369l63.746-31.163v130.694ZM278.04 349.787l-22.231 7.057a8 8 0 0 0-3.767 12.7l19.714 24.051-65.991 76.881 33.771-114.286a7.984 7.984 0 0 0 .328-2.267v-52.016q11.173 2.328 22.367 4.779Zm-158.827 12.406a8 8 0 0 0-5.249-5.349l-22.23-7.057 15.591-42.511c.071-.193.126-.388.181-.583q11.208-2.452 22.4-4.786v52.016a8.028 8.028 0 0 0 .328 2.269L164.2 470.961 98.01 393.6l19.721-24.059a8 8 0 0 0 1.482-7.348Zm26.7-52.376 33.684 29.731a8 8 0 0 0 10.588 0l33.683-29.731v42.949l-38.956 131.817-39-131.819Zm120.5-120.006v-45.3a22.649 22.649 0 0 1 0 45.3ZM102.061 56.428a87.5 87.5 0 0 1 152.19 8.286 8 8 0 0 0 7.106 4.453 21 21 0 0 1 18.233 31.119 7.985 7.985 0 0 0-.923 2.826l-3.429 26.475a38.6 38.6 0 0 0-8.831-1.072V114.56c0-9.241-5.622-19.456-13.078-23.76a15.605 15.605 0 0 0-15.959-.206c-33.711 19.464-67.9 19.465-101.61 0a8 8 0 0 0-4-1.072 25.066 25.066 0 0 0-25.037 25.038v13.955a38.417 38.417 0 0 0-15.094 3.159 159.734 159.734 0 0 1 10.432-75.246ZM84.277 167.163a22.678 22.678 0 0 1 22.446-22.648v45.3a22.678 22.678 0 0 1-22.446-22.652Zm38.79 29.844v-.034a64.181 64.181 0 0 1-.34-6.6V114.56a9.052 9.052 0 0 1 7.246-8.859c18.139 10.057 36.736 15.271 55.311 15.5 20.087.263 40.256-5.345 59.9-16.644 1.787.748 5.223 5.631 5.223 10v75.818a64.181 64.181 0 0 1-.34 6.6v.034a63.843 63.843 0 0 1-127 0Zm63.5 73.214a79.37 79.37 0 0 0 34.484-7.84c1 14.489 1.727 22.209 2.261 26.584l-38.423 33.914-38.424-33.914c.557-4.551 1.315-12.694 2.375-28.241a79.35 79.35 0 0 0 37.725 9.497ZM32.428 496h-.148a16.022 16.022 0 0 1-15.964-15.652c-.561-28.348-.383-87.954.618-117.822a62.608 62.608 0 0 1 30.459-41.84q20.661-5.106 41.587-9.857l-15.147 41.3a8 8 0 0 0 5.091 10.38l18.952 6.016-16.487 20.113a8 8 0 0 0 .108 10.271l82.485 96.414c-43.963.056-87.892.277-131.554.677Zm305.072 0h-.151c-43.751-.4-87.771-.621-131.824-.676l82.747-96.4a8 8 0 0 0 .116-10.282L271.9 368.523l18.953-6.016a8 8 0 0 0 5.09-10.38l-15.147-41.3q20.886 4.749 41.587 9.857a62.389 62.389 0 0 1 21.184 19.716h-8.382a20.87 20.87 0 0 0-20.645 18.064h-6.9a14.945 14.945 0 0 0-14.928 14.928v28.375a14.944 14.944 0 0 0 14.928 14.927h6.9a20.88 20.88 0 0 0 11.979 16.154V444.9a7.991 7.991 0 0 0 .488 2.751l17.164 46.867A15.78 15.78 0 0 1 337.5 496Zm-28.783-95.307v-26.23h5.618v26.23ZM361.752 496l-19.233-52.516v-8.727h23.13a7.966 7.966 0 0 0 .551 2.625L389.533 496Zm33.556-50.648h-8.715l-4.217-10.595h5.259l7.673 3.75ZM496 465.436a9.384 9.384 0 0 1-18.768 0V309.721a9.384 9.384 0 0 1 18.768 0Z" fill="#a9a9a9" opacity="1" data-original="#000000"></path></g></svg>
          <h2>No Employees Found</h2>
        </div>
      </div>
    </mat-dialog-content>


    <!-- buttons when showing increase/decrease modal -->
    <mat-dialog-actions style="position: relative !important;right: 20px;" align="end" *ngIf="!toShowInventoryItems && (operation_type == 1 || operation_type == 2 || operation_type == 3)">
      <button mat-button (click)="back()">Back</button>
      <button
        mat-flat-button
        color="accent"
        [disabled]="
          !purchaseListData.purchase_qty || !checkDateFilled() || !checkPurchasePriceFilled()
        "
        (click)="onPost()"
      >
        {{ editMode ? "Confirm" : "Confirm" }}
      </button>
    </mat-dialog-actions>
  
  <!-- buttons when showing inventory items -->
    <mat-dialog-actions style="position: relative !important;right: 20px;" align="end" *ngIf="toShowInventoryItems && employeeData.length > 0">
      <button mat-button mat-dialog-close>Cancel</button>
      <button
        [disabled]="
        selectedEmployee.length == 0
  
        "
        mat-flat-button
        color="accent"
        (click)="onSelectNext()"
      >
        Next
      </button>
    </mat-dialog-actions>

    